var exports = {
  "ke": "Progress__wmWMKj",
  "E3": "ProgressDescription__WuZixP",
  "lg": "WithNotice__aNAVU1",
};

module.exports = exports;
